<template>
  <div class="home">
    <v-app-bar absolute id="app-bar" color="#002C61" style="height: 64px" elevate-on-scroll>
      <!-- TBD -->
      <!-- https://alvarotrigo.com/blog/hamburger-menu-css/ -->
      <!-- https://codepen.io/alvarotrigo/pen/yLzaPVJ -->
      <div class="d-inline-block ml-1" style="width: 180px" @click="redirectPath('/frontPage')">
        <v-img :src="images.new_logo" width=200 alt="LOGO"></v-img>
      </div>
      <Breadcrumb />
      <v-spacer></v-spacer>
      <span class="headerName" style="color:#FFF">Hi, {{$root.LOGININFO.name}}</span>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="mx-1">
            <v-icon style="color:#FFF">mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item style="width: 100px;cursor: pointer" @click="redirectPath('/changePassword')">
            <v-list-item-title>修改密碼</v-list-item-title>
          </v-list-item>
          <v-list-item style="width: 100px;cursor: pointer" @click="logout">
            <v-list-item-title>登出</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-row id="app-content" class="fill-height mx-0" :style="viewStyle">
      <v-col class="pa-0 col-12" style="overflow-y: scroll; z-index: 0; flex: 1; transition: margin-left 0.3s">
        <router-view />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'Home',
  components: {Breadcrumb},
  data: () => ({
    images:{
      new_logo: require('@/assets/image/logo-W.png')
    },
    windowWidth: window.innerWidth,
    isSidebarCollapsed: false, // 側邊欄收縮狀態
    viewStyle:{},
  }),
  mounted(){
    if(!sessionStorage.getItem('manageMemberToken')){
      this.redirectPath('/login')
    }
    // window.onunload = (e)=>{
    //   this.logout()
    // };

    let self = this
    window.onresize = function windowResize () {
      // console.log('window.innerHeight: ' + window.innerHeight)
      self.$root.$emit('windowInnerHeight', window.innerHeight)
    }
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  created(){
    this.calculateWindows()
    this.$root.LOGININFO = {name:sessionStorage.getItem('manageMemberName')}

    if(sessionStorage.getItem('manageMemberSysId') === null){
      this.redirectPath('/login')
    }else{
      this.getData()
    }

    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  computed: {
    isMobile() {
      return this.windowWidth < 960;
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path).catch(err => {})
    },
    getData(){
      var self = this
      let userData
      var request = {
        method: 'GET',
        url: '/pmMemberManage/' + sessionStorage.getItem('manageMemberSysId'),
        params: {},
      }
      this.$http(request).then(function(response) {
        userData = response.data.data
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為Hom-7966')
      }).finally(()=>{
        if(this.$route.query.type == 'same'){
          self.redirectPath('/changePassword')
        }else{
          self.redirectPath('/frontPage')
        }
      })
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      if (this.isMobile) this.isSidebarCollapsed = true;
    },
    logout(){
      // remove sessionStorage
      sessionStorage.removeItem('manageMemberToken')
      sessionStorage.removeItem('manageMemberUserId')
      sessionStorage.removeItem('manageMemberName')
      sessionStorage.removeItem('manageMemberSysId')
      this.redirectPath('/login')
    }
  }
}
</script>

<style>
  .v-expansion-panel-header{
    border-radius: 0px
  }

  /** TBD **/
  /* https://codepen.io/alvarotrigo/pen/yLzaPVJ */
  #menu__toggle {
    opacity: 0;
  }
  #menu__toggle:checked + .menu__btn > span {
    transform: rotate(45deg);
  }
  #menu__toggle:checked + .menu__btn > span::before {
    top: 0;
    transform: rotate(0deg);
  }
  #menu__toggle:checked + .menu__btn > span::after {
    top: 0;
    transform: rotate(90deg);
  }
  #menu__toggle:checked ~ .menu__box {
    left: 0 !important;
  }
  .menu__btn {
    position: fixed;
    top: 30px;
    left: 20px;
    width: 26px;
    height: 26px;
    cursor: pointer;
    z-index: 1;
  }
  .menu__btn > span,
  .menu__btn > span::before,
  .menu__btn > span::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #215DA7;
    transition-duration: .25s;
  }
  .menu__btn > span::before {
    content: '';
    top: -8px;
  }
  .menu__btn > span::after {
    content: '';
    top: 8px;
  }
  .menu__box {
    display: block;
    position: fixed;
    top: 0;
    left: -100%;
    width: 300px;
    height: 100%;
    margin: 0;
    padding-left: 0px !important; 
    padding-top: 65px;
    list-style: none;
    background-color: #FFF;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
    transition-duration: .25s;
  }
  @media (max-width: 959px) {
    .hamburger {
      display: unset !important;
      width: 50px !important;
    }
    .breadcrumb, .headerName, .app-content-left {
      display: none !important;
    }
    .app-content-left {
      padding: 0px;
    }
  }
  /** TBD **/
</style>
